import { privateClient } from '../axiosClients/axiosClients';

export async function rejectFinalReview(params) {
  const response = await privateClient.post('/RejectFinalReview', params);
  const data = await response.json();
  return data;
}

export async function redoExecution(params) {
  const response = await privateClient.post('/redoExecution', {
    ...params,
  });
  return response.data;
}
